import { HelpCrunch } from './plugins/helpCrunch';
import './rawAnalytics';

const allPlugins = [];

export const ANALYTICS_TYPES = {
  HELP_CRUNCH: HelpCrunch,
};

const isAvailable = ({ ID }) => ID;

const extend = params => ({
  ...params,
  App: 'v2',
});

export class Analytics {
  constructor() {
    allPlugins.filter(isAvailable).forEach(({ init = () => {} }) => init());
  }

  pageView(path, plugins = allPlugins) {
    plugins.filter(isAvailable).forEach(({ pageView = () => {} }) => pageView(path));
  }

  trackEvent(name, params = {}, plugins = allPlugins) {
    const data = extend(params);
    plugins.filter(isAvailable).forEach(({ track = () => {} }) => track(name, data));
  }

  static getInstance({ getInstance = () => null } = {}) {
    return getInstance();
  }
}

export const analytics = new Analytics();
